export default {
  'app.pwa.offline': 'Usted está fuera de línea ahora',
  'app.pwa.serviceworker.updated': 'Nuevos contenidos disponibles',
  'app.pwa.serviceworker.updated.hint': 'Por favor presiona el botón de "Refrescar" para recargar la página actual',
  'app.pwa.serviceworker.updated.ok': 'Refrescar',
};
